export default __webpack_public_path__ + "static/media/carousel_3_300.3e1ccbb4.webp";